var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHome = function SvgIconHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M40.42 13.885 23.916 6.103a1.08 1.08 0 0 0-.962.02L8.082 13.873a1.08 1.08 0 0 0-.582.96v25.662c0 .598.484 1.082 1.082 1.082h10.414c.597 0 1.081-.484 1.081-1.082v-6.14c0-.597.485-1.081 1.082-1.081h7.899c.597 0 1.081.484 1.081 1.082v6.14c0 .597.485 1.081 1.082 1.081h8.737c.598 0 1.082-.484 1.082-1.082V14.864c0-.42-.242-.8-.62-.979"
  })));
};
export default SvgIconHome;